import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Button } from "@/shared/ui/Button";
import { Modal } from "@/shared/ui/Modal";
import { sidebarTranslations } from "@/shared/locales/sidebar";
import styles from "./LogoutConfirmModal.module.scss";
export const LogoutConfirmModal = ({ opened, onClose, onConfirm, language, }) => {
    const t = sidebarTranslations[language];
    const [submitting, setSubmitting] = useState(false);
    const handleConfirm = async () => {
        setSubmitting(true);
        try {
            await onConfirm();
            onClose();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsxs(Modal, { opened: opened, onClose: onClose, size: "sm", title: t.logoutConfirmTitle, closeOnBackdropClick: !submitting, closeOnEscape: !submitting, children: [_jsx("p", { className: styles.description, children: t.logoutConfirmDescription }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { variant: "ghost", size: "md", onClick: onClose, disabled: submitting, children: t.cancel }), _jsx(Button, { variant: "danger", size: "md", onClick: () => void handleConfirm(), disabled: submitting, children: submitting
                            ? language === "ru"
                                ? "Выходим…"
                                : "Signing out…"
                            : t.logout })] })] }));
};
